import type { StudyPublicGetMany } from '@/types';
import type { SelectionOption } from '@/types/autocomplete';

/**
 * Converts study search results to AutoComplete options
 *
 * @param studies - Array of study search results from API
 * @returns Array of SelectionOption objects
 *
 * @example
 * ```typescript
 * const options = mapStudiesToOptions(studies);
 * ```
 */
export function mapStudiesToOptions(studies: StudyPublicGetMany[]): SelectionOption[] {
  return studies.map(study => ({
    id: String(study.id),
    key: String(study.id),
    label: study.name,
    value: String(study.id),
    textValue: study.name,
  }));
}

/**
 * Finds an option by its value
 *
 * @param options - Array of SelectionOption items
 * @param value - Value to search for
 * @returns The matching option or null if not found
 *
 * @example
 * ```typescript
 * const option = findOptionByValue(options, 'some-id');
 * ```
 */
export function findOptionByValue(options: SelectionOption[], value: string | null): SelectionOption | null {
  if (!value) return null;
  return options.find(opt => opt.value === value) || null;
}
